import { render } from "./coach-chat.vue?vue&type=template&id=42e49c1f"
import script from "./coach-chat.vue?vue&type=script&lang=js"
export * from "./coach-chat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__